import { useRef, useState, useEffect } from 'react';
import { Link as RouterLink } from 'react-router-dom';
// material
import { Menu, MenuItem, IconButton, ListItemIcon, ListItemText } from '@mui/material';
// component
import CardMembershipIcon from '@mui/icons-material/CardMembership';
import CloudUploadIcon from '@mui/icons-material/CloudUpload';
import CloudDownloadIcon from '@mui/icons-material/CloudDownload';
import AddDocument from '../../../pages/AddDocument';
import Iconify from '../../../components/Iconify';

import AddMember from "../../../pages/AddMember";
import Axios from '../../../axios';


// ----------------------------------------------------------------------

export default function UserMoreMenu(props) {
  const ref = useRef(null);
  const [isOpen, setIsOpen] = useState(false);
  const [open, setOpen] = useState(false);
  const [documentOpen, setDocumentOpen] = useState(false);

  const { menu, setMenu, setMembers } = props;


  const handleDelete  = () => {
    if (window.confirm(`Are you sure you want to delete ${props.member.firstName} ${props.member.lastName} ?`)) {
      // Save it!
      Axios.delete(`/api/members/${props.member._id}`).then((response) => {
        if(response.message) {
          console.log("An error has occured")
        }
        else {
          // rerender table component
          setMenu(!menu)
        }
      })
      
    } else {
      // Do nothing!
      console.log('Thing was not saved to the database.');
    }
  }

  const handleUpdate = () => setOpen(!open);
  const handleUpload = () => setDocumentOpen(!documentOpen);
 useEffect(() => {
    Axios.get(`/api/members/`).then((response) => {
      setMembers(response.data);
    });
  }, [open]);

  // Generate Card Playground
  const handleGenerateCard = ()=>{
    Axios.get(`/api/members/card/${props.member._id}`, {
      responseType: 'blob'
    }).then((response) => {
      window.open(URL.createObjectURL(response.data));
    });
  }
  const handleDownload = () => {
    Axios.get(`/api/members/card/${props.member._id}`, { responseType: 'blob' })
      .then((response) => {
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', 'document.pdf'); // Set a default filename
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        window.URL.revokeObjectURL(url); // Free memory
      })
      .catch((error) => {
        console.error('Download failed:', error);
      });
  };
  

  return (
    <>
      <AddMember isOpen={open} toggle={handleUpdate} edit={open} member={props.member} />
      <AddDocument isOpen={documentOpen} toggle={handleUpload} data={ props.member} type='MEMBER' />
      <IconButton ref={ref} onClick={() => setIsOpen(true)}>
        <Iconify icon="eva:more-vertical-fill" width={20} height={20} />
      </IconButton>

      <Menu
        open={isOpen}
        anchorEl={ref.current}
        onClose={() => setIsOpen(false)}
        PaperProps={{
          sx: { width: 200, maxWidth: '100%' }
        }}
        anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
        transformOrigin={{ vertical: 'top', horizontal: 'right' }}
      >
        <MenuItem sx={{ color: 'text.secondary' }} onClick={handleDelete}>
          <ListItemIcon>
            <Iconify icon="eva:trash-2-outline" width={24} height={24} />
          </ListItemIcon>
          <ListItemText primary="Delete" primaryTypographyProps={{ variant: 'body2' }} />
        </MenuItem>

        <MenuItem component={RouterLink} to="#" sx={{ color: 'text.secondary' }} onClick={handleUpdate}>
          <ListItemIcon>
            <Iconify icon="eva:edit-fill" width={24} height={24} />
          </ListItemIcon>
          <ListItemText primary="Edit" primaryTypographyProps={{ variant: 'body2' }} />
        </MenuItem>

        <MenuItem sx={{ color: 'text.secondary' }} onClick={handleGenerateCard}>
          <ListItemIcon>
            <CardMembershipIcon width={24} height={24}/>
          </ListItemIcon>
          <ListItemText primary="Card" primaryTypographyProps={{ variant: 'body2' }} />
        </MenuItem>
        {/* new */}
        <MenuItem sx={{ color: 'text.secondary' }} onClick={handleUpload}>
          <ListItemIcon>
            <CloudUploadIcon width={24} height={24}/>
          </ListItemIcon>
          <ListItemText primary="Document" primaryTypographyProps={{ variant: 'body2' }} />
        </MenuItem>

        <MenuItem sx={{ color: 'text.secondary' }} onClick={handleDownload}>
          <ListItemIcon>
            <CloudDownloadIcon width={24} height={24}/>
          </ListItemIcon>
          <ListItemText primary="Download" primaryTypographyProps={{ variant: 'body2' }} />
        </MenuItem>
      </Menu>
    </>
  );
}
